//异步修改state的数据
const actions = {

};
export default actions;


// WEBPACK FOOTER //
// ./src/digitalHuman/store/actions.js